/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

/**
 * https://web.dev/custom-elements-best-practices/
 * Base CSS for all custom elements.
 */

:host {
  all: initial;
  display: block;
  visibility: inherit;
  box-sizing: border-box;
  font-size: inherit;
  pointer-events: inherit;
  contain: layout; /* https://developer.mozilla.org/en-US/docs/Web/CSS/contain */
  font-family: var(--nve-ref-font-family);
  outline: var(--nve-debug-element-outline, initial);
  color-scheme: var(--nve-sys-color-scheme);
}

*,
*::before,
*::after {
  box-sizing: inherit;
}

/* https://developers.google.com/web/fundamentals/web-components/best-practices#add-a-:host-display-style-that-respects-the-hidden-attribute */
[hidden],
:host([hidden]:not([nve-popover])) {
  display: none !important;
}

slot {
  display: contents;
}

/* https://coryrylan.com/blog/dont-override-css-outline-focus-styles */
:host(:focus-within) [focus-within],
:host(:focus) [focusable],
:host([tabindex='0']:focus) [focusable] {
  outline: Highlight solid 2px !important;
  outline: 5px auto -webkit-focus-ring-color !important;
}

:host([nofocus]) [focus-within] {
  outline: 0 !important;
}

:host(:focus-within:not(:focus-visible, [readonly])) [focus-within]:not([focusable='active']),
:host(:focus:not(:focus-visible)) [focusable]:not([focusable='active']),
:host([tabindex='0']:focus:not(:focus-visible)) [focusable]:not([focusable='active']) {
  outline: none !important;
  outline-offset: 0 !important;
}

@supports selector(:state(focus)) {
  :host(:state(focus)) [focusable],
  :host([tabindex='0']:state(focus)) {
    outline: Highlight solid 2px !important;
    outline: 5px auto -webkit-focus-ring-color !important;
  }
}
